import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DateRange} from '@pes/ui';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';

@Component({
    selector: 'lbpa-date-filter',
    templateUrl: './lbpa-date-filter.component.html'
})
export class LbpaDateFilterComponent {

    /**
     * Dispatches events each time the user enters filter tokens.
     */
    @Output() public dateRangeChange: EventEmitter<DateRange> = new EventEmitter<DateRange>();

    /**
     * The placeholder text for the filter input field.
     */
    @Input() public placeholder: string = 'back_office.component.date_filter.placeholder';

    /**
     * The tooltip of the dropdown button.
     */
    @Input() public tooltip: string = 'back_office.component.date_filter.options';

    /**
     * The aria label for the input.
     */
    @Input() public ariaLabel: string = 'back_office.component.date_filter.options';

    /**
     * Indicates whether the date fields are visible (true), or not (false).
     */
    public timeFilterVisible: boolean = true;

    /**
     * The reference to the model of the first date input.
     */
    public date1: NgbDate = null;

    /**
     * The reference to the model of the second date input.
     */
    public date2: NgbDate = null;

    private _dateRange: DateRange = {
        minDate: null,
        maxDate: null
    };

    /**
     * Toggles the date fields visibility.
     */
    protected toggleTimeFilter(): void {
        this.timeFilterVisible = !this.timeFilterVisible;
    }

    /**
     * Invoked each time the user selects a date in a date picker.
     *
     * @param {NgbDate} date the date object specified by the user.
     * @param {string} id the ID of the date picker that invokes this method.
     */
    protected onDateSelect(date: NgbDate, id: string): void {
        if (id === 'dp1') {
            this._dateRange.minDate = date;
        }
        if (id === 'dp2') {
            this._dateRange.maxDate = date;
        }
        this.dateRangeChange.emit(this._dateRange);
    }
}



// WEBPACK FOOTER //
// ./src/app/component/lbpa-date-filter/lbpa-date-filter.component.ts